import { gql } from "@apollo/client";

export const GET_BATCH_DETAILS = gql`
  query get_batches {
    courses_course_batches(order_by: { id: desc }) {
      batch_name
      from_date
      to_date
      slot_start_time
      course_id
      slot_end_time
      id
      max_learners
      min_learners
      slots_days
      platform
      type
      location
      is_demo
      partner {
        name
      }
      instructor {
        name
      }
      course {
        full_name
      }
    }
  }
`;
export const GET_LANGUAGES = gql`
  query GetLanguages {
    courses_languages(order_by: { display_name: asc }) {
      id
      display_name
    }
  }
`;
export const GET_BATCHES_WITH_FILTER = gql`
  query getBatchesWithFilter($where: courses_course_batches_bool_exp = {}) {
    courses_course_batches(where: $where, order_by: { id: desc }) {
      batch_name
      from_date
      to_date
      slot_start_time
      language_id
      course_id
      slot_end_time
      id
      max_learners
      min_learners
      userEnrollmentBatchArray_aggregate {
        aggregate {
          count
        }
      }
      slots_days
      platform
      type
      location
      is_demo
      partner {
        id
        name
      }
      project {
        id
        name
      }
      instructor {
        id
        name
      }
      course {
        full_name
      }
    }
  }
`;

export const GET_PARTNER_BATCHES = gql`
  query get_partner_batches($partnerIds: [Int!]!) {
    courses_course_batches(
      where: { partner_id: { _in: $partnerIds } }
      order_by: { id: desc }
    ) {
      partner_id
      batch_name
      from_date
      to_date
      slot_start_time
      slot_end_time
      id
      max_learners
      min_learners
      slots_days
      platform
      type
      location
      is_demo
      partner {
        name
      }
      instructor {
        name
      }
      course {
        full_name
      }
    }
  }
`;

export const GET_SLOTS_BY_BATCH_ID = gql`
  query get_slots($batch_id: Int) {
    courses_batch_slots(
      where: { batch_id: { _eq: $batch_id }, enable_slots: { _eq: true } }
      order_by: { slot_date: asc }
    ) {
      id
      slot_date
      slots_days
      endto_date
      platform
      batch_id
      meeting_link
      instructor_id
      event_id
      type
      location
      batch {
        batch_name
        instructor {
          id
          name
          email
        }
        course {
          full_name
        }
      }
    }
  }
`;

export const GET_SLOTS_ROW_DATA_BY_ID = gql`
  query get_slots_row_data($id: Int) {
    courses_batch_slots(where: { id: { _eq: $id } }) {
      id
      platform
      slot_date
      slots_days
      endto_date
      instructor_id
      batch_id
      event_id
      meeting_link
      type
      location

      batch {
        batch_name
      }
    }
  }
`;
export const GET_UPDATED_SLOTS = gql`
  query UpdateQuery($id: Int) {
    courses_batch_slots(where: { id: { _eq: $id } }) {
      batch_id
      endto_date
      event_id
      id
      meeting_link
      platform
      slot_date
      slots_days
      type
      location
    }
  }
`;

export const GET_COURSE_BATCHES = gql`
  query getCourseBatches($course_id: Int) {
    courses_course_batches(where: { course_id: { _eq: $course_id } }) {
      batch_name
      id
    }
  }
`;

export const GET_BATCH_ENROLLMENTS = gql`
  query getBatchUsers($batch_id: Int) {
    courses_user_batch_enrollment(where: { batch_id: { _eq: $batch_id } }) {
      user {
        id
        name
        email
      }
      course {
        id
        full_name
      }
    }
  }
`;

export const GET_BATCH_MEDIA_BY_ID = gql`
  query getBatchMedia($batchId: bigint) {
    courses_batch_media_relation(where: { batch_id: { _eq: $batchId } }) {
      id
      batch_id
      media_id
      remark
      media {
        id
        file_url
        file_name
        file_type
      }
    }
  }
`;

export const GET_BATCH_BY_ID = gql`
  query getBatchById($id: Int) {
    courses_course_batches(where: { id: { _eq: $id } }) {
      batch_name
      from_date
      to_date
      registration_end_date
      max_learners
      instructor_id
      course_id
      language_id
      slot_start_time
      slot_end_time
      partner {
        id
        name
      }
      project {
        id
        name
      }
      userEnrollmentBatchArray_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const UPDATE_BATCH_DETAILS = gql`
  mutation updateBatchDetails(
    $id: Int!
    $from_date: timestamptz
    $to_date: timestamptz
    $registration_end_date: timestamptz
    $max_learners: Int
    $batch_name: String
    $instructor_id: Int
    $course_id: Int
    $language_id: Int
    $slot_start_time: String
    $slot_end_time: String
    $partner_id: Int
    $project_id: bigint
  ) {
    update_courses_course_batches(
      where: { id: { _eq: $id } }
      _set: {
        from_date: $from_date
        to_date: $to_date
        registration_end_date: $registration_end_date
        max_learners: $max_learners
        batch_name: $batch_name
        instructor_id: $instructor_id
        course_id: $course_id
        language_id: $language_id
        slot_start_time: $slot_start_time
        slot_end_time: $slot_end_time
        partner_id: $partner_id
        project_id: $project_id
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
